export default class ZTablePagination {
  no
  size

  constructor (pageNo, pageSize) {
    this.no = pageNo
    this.size = pageSize
  }
}



// WEBPACK FOOTER //
// ./src/views/06Data-Management/02Normal/08VOCs-Data-Compare/ZTablePagination.js